import Vue from 'vue'
import Vuex from 'vuex'
import DataStorage from './modules/DataStorage'
import tags from './modules/tags.js'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    DataStorage,
    tags
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js